import React from 'react';
export function EngagementPlan() {
  return <div data-id="element-2161">
      <h1 className="text-2xl font-semibold text-gray-800 mb-2" data-id="element-2162">
        Engagement Plan
      </h1>
      <p className="text-gray-600 mb-8" data-id="element-2163">
        Configure your customer engagement strategies and workflows
      </p>

      <div className="space-y-6" data-id="element-2164">
        {/* Engagement Strategy */}
        <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-2165">
          <h2 className="text-lg font-semibold text-gray-800 mb-4" data-id="element-2166">
            Engagement Strategy
          </h2>
          <div className="space-y-4" data-id="element-2167">
            <div data-id="element-2168">
              <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2169">
                Default Follow-up Cadence
              </label>
              <select className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500" data-id="element-2170">
                <option data-id="element-2171">Immediate (within 1 hour)</option>
                <option data-id="element-2172">Same Day (within 8 hours)</option>
                <option data-id="element-2173">Next Day</option>
                <option data-id="element-2174">Custom</option>
              </select>
            </div>
            <div data-id="element-2175">
              <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2176">
                Maximum Follow-up Attempts
              </label>
              <input type="number" placeholder="3" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500" data-id="element-2177" />
            </div>
          </div>
        </div>

        {/* Communication Channels */}
        <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-2178">
          <h2 className="text-lg font-semibold text-gray-800 mb-4" data-id="element-2179">
            Preferred Communication Channels
          </h2>
          <div className="space-y-3" data-id="element-2180">
            <label className="flex items-center" data-id="element-2181">
              <input type="checkbox" defaultChecked className="w-4 h-4 text-blue-500 rounded border-gray-300 focus:ring-2 focus:ring-blue-500" data-id="element-2182" />
              <span className="ml-3 text-sm text-gray-700" data-id="element-2183">WhatsApp</span>
            </label>
            <label className="flex items-center" data-id="element-2184">
              <input type="checkbox" defaultChecked className="w-4 h-4 text-blue-500 rounded border-gray-300 focus:ring-2 focus:ring-blue-500" data-id="element-2185" />
              <span className="ml-3 text-sm text-gray-700" data-id="element-2186">Phone Call</span>
            </label>
            <label className="flex items-center" data-id="element-2187">
              <input type="checkbox" className="w-4 h-4 text-blue-500 rounded border-gray-300 focus:ring-2 focus:ring-blue-500" data-id="element-2188" />
              <span className="ml-3 text-sm text-gray-700" data-id="element-2189">Email</span>
            </label>
            <label className="flex items-center" data-id="element-2190">
              <input type="checkbox" className="w-4 h-4 text-blue-500 rounded border-gray-300 focus:ring-2 focus:ring-blue-500" data-id="element-2191" />
              <span className="ml-3 text-sm text-gray-700" data-id="element-2192">SMS</span>
            </label>
          </div>
        </div>

        {/* Auto-Assignment Rules */}
        <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-2193">
          <h2 className="text-lg font-semibold text-gray-800 mb-4" data-id="element-2194">
            Lead Auto-Assignment
          </h2>
          <div className="space-y-4" data-id="element-2195">
            <div data-id="element-2196">
              <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2197">
                Assignment Method
              </label>
              <select className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500" data-id="element-2198">
                <option data-id="element-2199">Round Robin</option>
                <option data-id="element-2200">Based on Availability</option>
                <option data-id="element-2201">Based on Performance</option>
                <option data-id="element-2202">Manual Assignment</option>
              </select>
            </div>
            <label className="flex items-center" data-id="element-2203">
              <input type="checkbox" defaultChecked className="w-4 h-4 text-blue-500 rounded border-gray-300 focus:ring-2 focus:ring-blue-500" data-id="element-2204" />
              <span className="ml-3 text-sm text-gray-700" data-id="element-2205">
                Automatically assign hot leads to top performers
              </span>
            </label>
          </div>
        </div>

        <div className="flex justify-end" data-id="element-2206">
          <button className="px-6 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition-colors font-medium" data-id="element-2207">
            Save Changes
          </button>
        </div>
      </div>
    </div>;
}